import { createSlice } from "@reduxjs/toolkit";
const Vehicles_Id = localStorage.getItem("setVechicle_ID");
const globalReducer = createSlice({
	name: "global",
	initialState: {
		success: "",
		vehicle_id: Vehicles_Id ? Vehicles_Id : "",
	},
	reducers: {
		setSuccess: (state, action) => {
			state.success = action.payload;
		},
		clearMessage: (state) => {
			state.success = "";
		},
		setVechicle_ID: (state, action) => {
			state.vehicle_id = action.payload;
		},
		clearVechicle_ID: (state) => {
			state.vehicle_id = "";
			localStorage.removeItem("setVechicle_ID");
		},
	},
});
export const { setSuccess, clearMessage, clearVechicle_ID, setVechicle_ID } =
	globalReducer.actions;
export default globalReducer.reducer;
